import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function EmailLogPage() {
  const [emails, setEmails] = useState(null);

  useEffect(() => {
    api.get("/admin/emails").then((r) => setEmails(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-6" data-testid="email-log-page">
      <div>
        <h1 className="font-heading text-2xl font-extrabold text-navy sm:text-3xl">Notification Log</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          All outbound notifications. Emails are currently logged here (mocked delivery).
        </p>
      </div>

      <div className="overflow-hidden rounded-md border border-border bg-card">
        {!emails ? (
          <div className="p-6 text-sm text-muted-foreground">Loading…</div>
        ) : emails.length === 0 ? (
          <div className="p-6 text-sm text-muted-foreground" data-testid="email-log-empty">No notifications sent yet.</div>
        ) : (
          emails.map((m) => (
            <div key={m.id} data-testid={`email-row-${m.id}`} className="flex flex-col gap-1 border-b border-border px-5 py-4 last:border-b-0 hover:bg-slate-50 sm:flex-row sm:items-start sm:gap-4">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-navy/5 text-navy">
                <Mail className="h-4 w-4" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-navy">{m.subject}</div>
                <div className="text-xs text-muted-foreground">To: {m.to}</div>
                <p className="mt-1 text-xs text-slate-600">{m.body}</p>
              </div>
              <div className="shrink-0 text-right">
                <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-slate-500">{m.category}</span>
                <div className="mt-1 text-xs text-muted-foreground">{new Date(m.sent_at).toLocaleString("en-AU")}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
